export class Mode {
    static Readonly = 0;
    static Editable = 1;
}